import React, { createRef, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';

import AGFunction from '../components/AGFunction';
import ComFunction from '../components/ComFunction';
import EntryBase from '../components/EntryBase';
import EntryFiles from '../components/EntryFiles';
import EntryGridAr from '../components/EntryGridAr';
import EntryImages from '../components/EntryImages';
import EntryLayout from '../components/EntryLayout';
import EntryRemarks from '../components/EntryRemarks';
import EntrySetting from '../components/EntrySetting';
import MasterBase from '../components/MasterLayout';
import {
    DeepCopy,
    getcontroller,
    getformid,
    getglobaldata,
    getsubkey,
    initializedata,
    isEmpty,
    isEnabled,
    NumConv,
    Round,
    setglobaldata
} from '../modules/appLibrary';
import { cfFileUpload, cfMargeUploadFiles, cfNewUploadFile } from '../modules/commodule';
import {
    changestatus,
    entrytriggercall,
    listoption,
    listtabs,
    setgridlist
} from '../modules/formstore';
import { setimagelist } from '../modules/imagedlgstore';
import { setentrypanel } from '../modules/toolpanelstore';
import {
    addentrylayout,
    setentrylayout,
    setentrystartup
} from '../modules/toolpanelstore';

const ComFunc = React.forwardRef(ComFunction);
const AGFunc = React.forwardRef(AGFunction);

export const RawStockCnt = props => {
    const panelsdef = [];
    const G_id = { BASE: '0', IMAGE: 'pic', FILE: 'file', NB: 'nb', PL: 'pl' };
    const primarykeys = ['ZTN_DENNO'];
    const formid = getformid('RawStockCnt', props.location.search);
    const controller = getcontroller('RawStockCnt', props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const formstatus = useSelector(state => state.form.status);
    const gridlist = useSelector(state => state.form.gridlist);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const fnc = useRef();
    const AGRef = useRef();
    const baseRef = useRef();
    const entryBodyRef = useRef(null);

    const entrydataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);
    const gridapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);

    const [panel, setpanel] = useState(panelsdef);
    const [columninfo, setcolumninfo] = useState(null);
    const [columns, setcolumns] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [edittingcode, setedittingcode] = useState('');
    const [requestFlag, setRequestFlag] = useState('0');
    const [viewListType, setViewListType] = useState('0');
    const [detailMaterialCategory, setDetailMaterialCategory] = useState('1');
    const [, setUpdate] = useState(false);

    const actionurl = {
        getlist: 'RawStockCnt/GetListData',
        delete: 'RawStockCnt/Delete'
    };

    // RawStockCnt is existing-data entry only. Disable every operation that creates a new record.
    const suppressaction = [
        { type: '0', action: 'INSERT' },
        { type: '0', action: 'UPDATE' },
        { type: '0', action: 'NEW FORM' },
        { type: '0', action: 'COPY FORM' },
        { type: '1', action: 'INSERT' },
        { type: '1', action: 'UPDATE' },
        { type: '1', action: 'NEW FORM' },
        { type: '1', action: 'COPY FORM' }
    ];

    const navmenu = [
        { status: 'VIEW', menuid: 'excel', icon: 'file_download', label: 'Excel', title: '現在のシート内容をExcelに出力します' },
        { status: 'VIEW', menuid: 'request', icon: 'send', label: '申請' },
        { status: 'VIEW', menuid: 'request_cancel', icon: 'cancel', label: '申請解除' },
        { status: 'VIEW', menuid: 'print_inventory', icon: 'print', label: '原材料棚卸帳票発行' },
        { status: 'ENTRY FORM', menuid: 'request', icon: 'send', label: '申請' },
        { status: 'ENTRY FORM', menuid: 'request_cancel', icon: 'cancel', label: '申請解除' },
        { status: 'ENTRY FORM', menuid: 'print_inventory', icon: 'print', label: '原材料棚卸帳票発行' }
    ];

    function requestNavmenu() {
        const menu = [
            { status: 'VIEW', menuid: 'excel', icon: 'file_download', label: 'Excel', title: '現在のシート内容をExcelに出力します' }
        ];

        // 一覧の申請系コマンドは「明細無」の場合だけ表示する。
        if (String(viewListType) === '0') {
            menu.push({ status: 'VIEW', menuid: 'request', icon: 'send', label: '申請' });
            menu.push({ status: 'VIEW', menuid: 'request_cancel', icon: 'cancel', label: '申請解除' });
        }
        menu.push({ status: 'VIEW', menuid: 'print_inventory', icon: 'print', label: '原材料棚卸帳票発行' });

        // 入力画面では申請フラグに応じて、どちらか一方だけ表示する。
        if (String(requestFlag) === '1') {
            menu.push({ status: 'ENTRY FORM', menuid: 'request_cancel', icon: 'cancel', label: '申請解除' });
        } else {
            menu.push({ status: 'ENTRY FORM', menuid: 'request', icon: 'send', label: '申請' });
        }
        menu.push({ status: 'ENTRY FORM', menuid: 'print_inventory', icon: 'print', label: '原材料棚卸帳票発行' });
        return menu;
    }

    function rerender() {
        setUpdate(value => !value);
    }

    function gridIndex(targetPanel) {
        if (isEmpty(targetPanel)) return -1;
        return gridlist.findIndex(item =>
            item.id === targetPanel.id &&
            (isEmpty(targetPanel.type) || item.type === targetPanel.type)
        );
    }

    function setGridData(targetPanel, data) {
        const index = gridIndex(targetPanel);
        if (index === -1 || isEmpty(griddataRefs.current[index])) return;
        griddataRefs.current[index].current = data;
    }

    function gridData(targetPanel) {
        const index = gridIndex(targetPanel);
        if (index === -1 || isEmpty(griddataRefs.current[index])) return null;
        return griddataRefs.current[index].current;
    }

    function gridApi(targetPanel) {
        const index = gridIndex(targetPanel);
        if (index === -1 || isEmpty(gridapiRefs.current[index])) return null;
        return gridapiRefs.current[index].current;
    }

    function roundMeterTotal(value, columnId) {
        const column = (columninfo || []).find(item => item.columnid === columnId);
        const configuredDecimalPlace = Number(column?.decimalplace);
        const decimalPlace = Number.isInteger(configuredDecimalPlace) && configuredDecimalPlace >= 0
            ? configuredDecimalPlace
            : 2;
        return Round(NumConv(value), decimalPlace);
    }

    function roundUpByColumn(value, columnId, defaultDecimalPlace = 2) {
        const column = (columninfo || []).find(item => item.columnid === columnId);
        const configuredDecimalPlace = Number(column?.decimalplace);
        const decimalPlace = Number.isInteger(configuredDecimalPlace) && configuredDecimalPlace >= 0
            ? configuredDecimalPlace
            : defaultDecimalPlace;
        const scale = Math.pow(10, decimalPlace);
        return Math.ceil(NumConv(value) * scale) / scale;
    }

    function totalRow(detailRows, totalType) {
        const totals = {
            book: roundMeterTotal((detailRows || []).reduce((sum, row) => sum + NumConv(row.ZTNM_METERSU), 0), 'ZTNM_METERSU'),
            first: roundMeterTotal((detailRows || []).reduce((sum, row) => sum + NumConv(row.ZTNM_FIRSTMETERSUJ), 0), 'ZTNM_FIRSTMETERSUJ'),
            actual: roundMeterTotal((detailRows || []).reduce((sum, row) => sum + NumConv(row.ZTNM_METERSUJ), 0), 'ZTNM_METERSUJ'),
            difference: 0
        };
        totals.difference = roundMeterTotal(totals.actual - totals.book, 'ZTNM_METERSUC');
        const row = {
            rowid: 'TOTAL',
            grip: '計',
            ZTNM_METERSU: totals.book,
            ZTNM_FIRSTMETERSUJ: totals.first,
            ZTNM_METERSUJ: totals.actual,
            ZTNM_METERSUC: totals.difference
        };

        (columninfo || []).filter(column => column.type === totalType).forEach(column => {
            const id = String(column.columnid || '').toUpperCase();
            const name = String(column.columnnm || '').replace(/\s/g, '');
            if (name.includes('初回実棚')) row[column.columnid] = totals.first;
            else if (name.includes('調整後実棚')) row[column.columnid] = totals.actual;
            else if (name.includes('調整') || name.includes('差異')) row[column.columnid] = totals.difference;
            else if (name.includes('帳棚')) row[column.columnid] = totals.book;
            else if (id.includes('FIRST') && id.includes('METERSU')) row[column.columnid] = totals.first;
            else if (id.includes('METERSUC')) row[column.columnid] = totals.difference;
            else if (id.includes('METERSUJ')) row[column.columnid] = totals.actual;
            else if (id.includes('METERSU')) row[column.columnid] = totals.book;
        });

        return [row];
    }

    function hasNumericValue(value) {
        if (value === null || value === undefined) return false;
        const text = String(value).trim();
        return text !== '' && text !== '-';
    }

    function calculateDetailRows(rows) {
        return (rows || []).map(row => {
            if (isEmpty(row) || row.rowid === 'TOTAL') return row;

            if (hasNumericValue(row.ZTNM_METERSU) || hasNumericValue(row.ZTNM_METERSUJ)) {
                row.ZTNM_METERSUC = roundMeterTotal(
                    NumConv(row.ZTNM_METERSUJ) - NumConv(row.ZTNM_METERSU),
                    'ZTNM_METERSUC'
                );

                const standardLength = NumConv(row.ZAI_KIKAKUE);
                row.ZTNM_TANSUC = standardLength > 0
                    ? roundUpByColumn(row.ZTNM_METERSUC / standardLength, 'ZTNM_TANSUC')
                    : 0;
            }

            return row;
        });
    }

    function setApiRowData(api, rows) {
        if (isEmpty(api)) return;
        if (typeof api.setGridOption === 'function') {
            api.setGridOption('rowData', rows);
        } else if (typeof api.setRowData === 'function') {
            api.setRowData(rows);
        }
    }

    function primarykey() {
        const column = textfieldsall.find(item => item.primarykey);
        return isEmpty(column) ? primarykeys[0] : column.columnid;
    }

    function currentListType() {
        if (!isEmpty(baseRef.current) && typeof baseRef.current.ListType === 'function') {
            return baseRef.current.ListType();
        }
        return '0';
    }

    function applyRawStockCntFieldWidths(fields) {
        return (fields || []).map(field => {
            const name = String(field.columnnm || '').trim();
            if (name === '申請状態' || name === 'OPPI公開状態') {
                return { ...field, width: 1 }; // 50%
            }
            if (name === '摘要') {
                return { ...field, width: 3 }; // 100%
            }
            return field;
        });
    }

    // カラーは複合キーのため s_layout の datatype は TEXT のまま使用し、
    // 棚卸入力の明細グリッドだけ既存のカラー検索リストへ接続します。
    function applyRawStockCntDetailSearch(column) {
        if (isEmpty(column.colinfo)) return;

        if (column.colId === 'ZTNM_SOKOCD') {
            column.colinfo = {
                ...column.colinfo,
                datatype: '6',
                dataid: 'M_TOR',
                dbcolumn: 'TOR_NAMERNM',
                keyinfo: 'TOR_KUBUN=ZTNM_SOKOKBN',
                searchparam: {
                    requirement: 'TOR_KUBUN=ZTNM_SOKOKBN;TOR_INVALID=0'
                },
                multiple: false,
                primary: false
            };
            return;
        }

        if (column.colId !== 'ZTNM_ZAICOLORCD') return;

        const accessory = detailMaterialCategory === '2';
        const requirement = accessory
            ? 'FZKC_TORKUBUN=ZTNM_ZAISIIRESAKIKBN;FZKC_TORCODE=ZTNM_ZAISIIRESAKICD;FZKC_TORSUBCODE=ZTNM_ZAISIIRESAKISUBCD;FZKC_BRDCODE=ZTNM_BRDCD;FZKC_FHINBAN=ZTNM_ZAIHINBAN;FZKC_INVALID=0'
            : 'ZAIC_TORKUBUN=ZTNM_ZAISIIRESAKIKBN;ZAIC_TORCODE=ZTNM_ZAISIIRESAKICD;ZAIC_TORSUBCODE=ZTNM_ZAISIIRESAKISUBCD;ZAIC_BRDCODE=ZTNM_BRDCD;ZAIC_HINBAN=ZTNM_ZAIHINBAN;ZAIC_INVALID=0';

        column.colinfo = {
            ...column.colinfo,
            datatype: '6',
            dataid: accessory ? 'M_FZKC' : 'FM_ZAIC_COLOR',
            dbcolumn: accessory ? 'FZKC_FCOLORNM' : 'ZAIC_COLORNM',
            keyinfo: '',
            searchparam: { requirement: requirement },
            trigger: [],
            multiple: false,
            primary: false
        };
    }

    function queryRawStockCntDetailSearch(column, rowdata) {
        if (column?.columnid !== 'ZTNM_SOKOCD') return column;
        if (!isEmpty(rowdata?.ZTNM_SOKOKBN)) return column;

        fnc.current.warnmsg('先に在庫場所区分を選択してください。');
        return false;
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;

        fnc.current.postaxios(
            'common/GetListTabs',
            { panels: panelsdef, controller: controller, subkey: subkey },
            {
                onSuccess: function (data) {
                    const entryColumnInfo = applyRawStockCntFieldWidths(data.colinfo);
                    const entryColumns = applyRawStockCntFieldWidths(data.columns);
                    setpanel(data.panels || []);
                    dispatch(setentrypanel({
                        layouts: data.layouts || [],
                        prelayout: data.prelayout,
                        initlayout: isEmpty(data.initlayout) ? ' ' : data.initlayout,
                        fitColumn: data.fitColumn
                    }));

                    setcolumninfo(entryColumnInfo);
                    setcolumns(entryColumns);
                    settextfieldsall(entryColumnInfo.filter(item => item.logpid === G_id.BASE));
                    settextfields(entryColumns.filter(item => item.logpid === G_id.BASE));
                    fnc.current.initMaster(data.master);

                    let index = 0;
                    const grids = [];
                    (data.panels || []).filter(item => item.grid).forEach(item => {
                        gridapiRefs.current[index] = createRef();
                        griddataRefs.current[index] = createRef();
                        gridcolRefs.current[index] = createRef();
                        grids.push({ id: item.id, type: item.type, index: index });
                        index++;

                        const total = entryColumnInfo.find(col => col.logpid === 'T' + item.id);
                        if (!isEmpty(total)) {
                            gridapiRefs.current[index] = createRef();
                            griddataRefs.current[index] = createRef();
                            gridcolRefs.current[index] = createRef();
                            grids.push({ id: 'T' + item.id, type: total.type, index: index });
                            index++;
                        }
                    });
                    dispatch(setgridlist(grids));
                    fnc.current.wait(false);
                }
            }
        );
    }, [search]);

    useEffect(() => {
        if (isEmpty(baseRef.current) || typeof baseRef.current.ChangeNavmenu !== 'function') return;
        baseRef.current.ChangeNavmenu(requestNavmenu());
    }, [formstatus, requestFlag, viewListType]);

    function Show(data, pushcode) {
        let code = '';

        if (data === undefined) {
            code = !isEmpty(pushcode) ? pushcode : edittingcode;
        } else {
            setglobaldata('entryrowdata', data);
            if (data !== null) code = data[primarykey()] || '';
        }

        setedittingcode(code);
        if (isEmpty(columninfo)) return false;

        clearform(code === '');
        if (code !== '') LoadData(code);
        return true;
    }

    function onFirstDataRendered(params, targetPanel) {
        const index = gridIndex(targetPanel);
        if (index === -1) return;
        gridapiRefs.current[index].current = params.api;

        const rows = gridData(targetPanel) || [];
        setApiRowData(params.api, rows);
        if (!String(targetPanel.id || '').startsWith('T')) {
            updateDetailAndTotal(targetPanel, rows, params.api);
        }
    }

    function storeRowData(targetPanel) {
        if (isEmpty(AGRef.current)) return;

        const targets = isEmpty(targetPanel) ? gridlist : [targetPanel];
        targets.forEach(item => {
            const api = gridApi(item);
            if (!isEmpty(api)) setGridData(item, AGRef.current.GetDatasource(api));
        });
    }

    function updateDetailAndTotal(targetPanel, rows, detailApi) {
        const detailRows = calculateDetailRows(rows);
        setGridData(targetPanel, detailRows);
        const sourceApi = isEmpty(detailApi) ? gridApi(targetPanel) : detailApi;
        if (!isEmpty(sourceApi) && typeof sourceApi.refreshCells === 'function') {
            sourceApi.refreshCells({ force: true });
        }

        const totalPanel = gridlist.find(item => item.id === 'T' + targetPanel.id);
        if (isEmpty(totalPanel)) return;

        const totalData = totalRow(detailRows, totalPanel.type);
        setGridData(totalPanel, totalData);
        setApiRowData(gridApi(totalPanel), totalData);
    }

    function refreshDetailAndTotal(targetPanel, api) {
        const sourceApi = isEmpty(api) ? gridApi(targetPanel) : api;
        const rows = !isEmpty(sourceApi) && !isEmpty(AGRef.current)
            ? AGRef.current.GetDatasource(sourceApi)
            : (gridData(targetPanel) || []);
        updateDetailAndTotal(targetPanel, rows, sourceApi);
    }

    function detailValueChanged(targetPanel, params) {
        if (params?.colDef?.colId === 'ZTNM_SOKOKBN' && params.newValue !== params.oldValue) {
            params.data.ZTNM_SOKOCD = '';
            params.data.ZTNM_SOKOSUBCD = '';
            params.data.ZTNM_SOKOCD_cd = '';
            params.data.ZTNM_SOKOCD_nm = '';
            if (!isEmpty(params.api) && typeof params.api.refreshCells === 'function') {
                params.api.refreshCells({
                    rowNodes: isEmpty(params.node) ? undefined : [params.node],
                    columns: ['ZTNM_SOKOCD'],
                    force: true
                });
            }
        }

        refreshDetailAndTotal(targetPanel, params?.api);
    }

    function clearform(newform) {
        entrydataRef.current = initializedata(textfieldsall, staff);
        setRequestFlag('0');
        imageRef.current = null;
        fileRef.current = null;
        gridlist.forEach(item => setGridData(item, null));
        dispatch(setimagelist([]));
        fnc.current.modify(false);
        rerender();

        if (!isEnabled(newform)) return;

        fnc.current.postaxios(
            'common/GetInitSqlValue',
            { colinfo: textfieldsall },
            {
                onSuccess: function (data) {
                    const fields = textfieldsall;
                    Object.keys(data.returnData || {}).forEach(key => {
                        const field = fields.find(item => item.columnid === key);
                        if (!isEmpty(field)) field.initvalue = data.returnData[key];
                    });
                    entrydataRef.current = initializedata(fields, staff);
                    rerender();
                }
            },
            true
        );
    }

    function LoadData(code) {
        if (isEmpty(code)) return;

        fnc.current.postaxios(
            'RawStockCnt/GetData',
            {
                code: code,
                colinfo: columninfo,
                columns: columns,
                controller: controller,
                panels: panel,
                type: currentListType()
            },
            {
                onSuccess: function (data) {
                    fnc.current.margeMaster(data.master || []);
                    entrydataRef.current = data.data || {};
                    setDetailMaterialCategory(String(entrydataRef.current.ZTN_ZAIRYOKBN ?? '1'));
                    setRequestFlag(String(entrydataRef.current.ZTN_REQFLG ?? '0'));
                    const detailByType = {};
                    (gridlist || []).forEach(item => {
                        if (!String(item.id || '').startsWith('T')) {
                            const detailRows = calculateDetailRows((data.detail || {})[item.type] || []);
                            detailByType[item.type] = detailRows;
                            setGridData(item, detailRows);
                            setApiRowData(gridApi(item), detailRows);
                            return;
                        }

                        const sourcePanel = (panel || []).find(candidate => 'T' + candidate.id === item.id);
                        const detailRows = isEmpty(sourcePanel)
                            ? []
                            : detailByType[sourcePanel.type]
                                || calculateDetailRows((data.detail || {})[sourcePanel.type] || []);
                        const totalData = totalRow(detailRows, item.type);
                        setGridData(item, totalData);
                        setApiRowData(gridApi(item), totalData);
                    });
                    imageRef.current = data.images || [];
                    fileRef.current = data.files || [];
                    dispatch(setimagelist(data.images || []));
                    rerender();
                    dispatch(changestatus('ENTRY FORM'));
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    fnc.current.warnmsg(data.errDescription || 'データの取得に失敗しました');
                    dispatch(changestatus('VIEW'));
                    fnc.current.wait(false);
                }
            }
        );
    }

    function BuildEntryParamData(noconfirm) {
        storeRowData();
        const detail = {};
        gridlist.filter(item =>
            item.id !== G_id.PL &&
            !String(item.id || '').startsWith('T')
        ).forEach(item => {
            detail[item.type] = gridData(item) || [];
        });

        return {
            type: currentListType(),
            controller: formid,
            data: entrydataRef.current,
            detail: detail,
            images: imageRef.current,
            files: fileRef.current,
            colinfo: columninfo,
            code: edittingcode,
            noconfirm: noconfirm
        };
    }

    function Save(finallycallback, refreshList, noconfirm) {
        const newfiles = formstatus === 'ENTRY FORM' ? [] : cfNewUploadFile(imageRef, fileRef);
        if (newfiles.length > 10) {
            fnc.current.warnmsg('新規登録できるアップロードファイル数は10までです。');
            return;
        }

        const paramdata = BuildEntryParamData(noconfirm);
        const url = formstatus === 'ENTRY FORM'
            ? 'RawStockCnt/UpdateEntry'
            : 'RawStockCnt/InsertEntry';

        fnc.current.postaxios(
            url,
            paramdata,
            {
                onSuccess: function (data) {
                    const warnings = data.warning || [];
                    if (warnings.length !== 0) {
                        if (isEnabled(data.confirm)) {
                            const messages = ['内容を確認しそのまま登録する場合はOK,修正する場合はCancelを選択してください', '　'];
                            warnings.forEach(item => messages.push('・' + item.message));
                            fnc.current.confmsg(messages, () => Save(finallycallback, refreshList, true));
                        } else {
                            fnc.current.showwarndescription(warnings.length + '件の制約違反により登録できませんでした。', warnings);
                        }
                        fnc.current.wait(false);
                        return;
                    }

                    fnc.current.modify(false);
                    const code = data.request || edittingcode;
                    if (formstatus !== 'ENTRY FORM') {
                        entrydataRef.current[primarykey()] = code;
                        setedittingcode(code);
                        dispatch(changestatus('ENTRY FORM'));
                    }

                    if (newfiles.length !== 0) {
                        cfFileUpload('RawStockCnt', code, newfiles, fnc, () => LoadData(code));
                    } else {
                        fnc.current.success();
                        if (formstatus === 'ENTRY FORM' && typeof finallycallback === 'function') {
                            if (typeof refreshList === 'function') {
                                refreshList(false);
                            } else {
                                const row = getglobaldata('entryrowdata');
                                const refreshedRow = {
                                    ...(row || {}),
                                    ...(data.data || {})
                                };
                                if (!isEmpty(row)) refreshedRow.rowid = row.rowid;
                                if (!isEmpty(refreshedRow)) finallycallback(refreshedRow);
                            }
                        }
                        LoadData(code);
                    }
                    fnc.current.wait(false);
                },
                errmsg: '登録に失敗しました'
            }
        );
    }

    function Delete(finallycallback) {
        if (isEmpty(edittingcode)) {
            fnc.current.warnmsg('棚卸番号が取得できません。');
            fnc.current.wait(false);
            return;
        }

        fnc.current.postaxios(
            'RawStockCnt/Delete',
            {
                code: edittingcode,
                rowdata: [{ rowid: edittingcode }],
                controller: controller,
                type: currentListType(),
                tabletype: '0'
            },
            {
                onSuccess: function () {
                    fnc.current.success();
                    fnc.current.modify(false);
                    if (typeof finallycallback === 'function') {
                        finallycallback(edittingcode, primarykeys);
                    } else {
                        dispatch(changestatus('VIEW'));
                    }
                    fnc.current.wait(false);
                },
                errmsg: '削除に失敗しました'
            }
        );
    }

    function normalizeYearMonth(value) {
        const text = String(value ?? '').trim().replace(/[/-]/g, '');
        return /^\d{6}/.test(text) ? text.substring(0, 6) : '';
    }

    function PrintInventoryReport() {
        const selectedRows = baseRef.current?.GetSelectrowdata() || [];
        const entryRow = {
            ...(getglobaldata('entryrowdata') || {}),
            ...(entrydataRef.current || {})
        };
        const sourceRows = formstatus === 'VIEW'
            ? selectedRows
            : (isEmpty(entryRow) ? [] : [entryRow]);

        if (sourceRows.length === 0) {
            fnc.current.warnmsg('対象データを選択してください');
            return;
        }
        const denNoList = [...new Set(sourceRows
            .map(row => String(row.ZTN_DENNO ?? row.ZTNM_DENNO ?? '').trim())
            .filter(value => value !== ''))];
        const yearMonths = [...new Set(sourceRows
            .map(row => normalizeYearMonth(row.ZTN_DATE ?? row.ZTNM_DATE))
            .filter(value => value !== ''))];
        const materialCategories = [...new Set(sourceRows
            .map(row => String(row.ZTN_ZAIRYOKBN_cd ?? row.ZTN_ZAIRYOKBN ?? '').trim())
            .filter(value => value !== ''))];

        if (denNoList.length === 0) {
            fnc.current.warnmsg('棚卸番号が取得できません。');
            return;
        }
        if (yearMonths.length !== 1 || materialCategories.length !== 1) {
            fnc.current.warnmsg('同じ棚卸年月・材料区分のデータを選択してください。');
            return;
        }

        fnc.current.postaxios(
            'ZairyoTanaoroshiExcelReport/Generate',
            {
                denNoList: denNoList,
                targetYearMonth: yearMonths[0],
                zairyoKbn: materialCategories[0],
                syoyuCd: '',
                brdCd: '',
                sokoKbn: '',
                sokoCd: '',
                showZeroBookMeter: false
            },
            {
                onSuccess: function (data) {
                    fnc.current.filedownload('excel/ExcelDownload', {
                        excelfile: data.returnData.filename,
                        dnfile: data.returnData.dnfile
                    });
                    fnc.current.wait(false);
                },
                errmsg: '原材料棚卸帳票の発行に失敗しました'
            }
        );
    }

    function ChangeRequestStatus(apply, refreshList) {
        const sourceRows = formstatus === 'VIEW'
            ? (baseRef.current?.GetSelectrowdata() || [])
            : (isEmpty(entrydataRef.current) ? [] : [entrydataRef.current]);

        if (formstatus === 'VIEW' && sourceRows.length === 0) {
            fnc.current.warnmsg('対象データを選択してください。');
            return;
        }

        const targetRows = sourceRows.filter(row => {
            const reqFlg = String(row.ZTN_REQFLG ?? '0');
            return apply ? reqFlg !== '1' : reqFlg === '1';
        });
        const denNos = [...new Set(targetRows
            .map(row => String(row.ZTN_DENNO ?? '').trim())
            .filter(value => value !== ''))];

        if (denNos.length === 0) {
            fnc.current.warnmsg(apply
                ? '未申請の対象データを選択してください。'
                : '申請済の対象データを選択してください。');
            return;
        }

        fnc.current.postaxios(
            apply ? 'RawStockCnt/ApplyRequest' : 'RawStockCnt/CancelRequest',
            {
                type: currentListType(),
                rowdata: denNos.map(denNo => ({ ZTN_DENNO: denNo }))
            },
            {
                onSuccess: function () {
                    fnc.current.success();
                    if (formstatus === 'VIEW') {
                        if (typeof refreshList === 'function') refreshList(false);
                    } else {
                        LoadData(edittingcode);
                    }
                    fnc.current.wait(false);
                },
                errmsg: apply ? '申請処理に失敗しました。' : '申請解除処理に失敗しました。'
            }
        );
    }

    function MenuAction(action, finallycallback, refreshList) {
        if (action === 'print_inventory') {
            PrintInventoryReport();
            return;
        }
        if (action === 'request') {
            ChangeRequestStatus(true, refreshList);
            return;
        }
        if (action === 'request_cancel') {
            fnc.current.confmsg(
                '申請解除します。宜しいでしょうか？',
                () => ChangeRequestStatus(false, refreshList)
            );
            return;
        }
        if (action === 'save') Save(finallycallback, refreshList);
        if (action === 'delete') Delete(finallycallback);
        if (action === 'clear') clearform(true);
    }

    function fileuploaded(data) {
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {
            cfMargeUploadFiles(imageRef, data.images);
            cfMargeUploadFiles(fileRef, data.files);
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current || []));
        rerender();
    }

    function ValueChanged(id) {
        const column = (columninfo || []).find(item => item.columnid === id);
        if (!isEmpty(column) && column.extriggerref) dispatch(entrytriggercall(id));
    }

    function tabletype(id) {
        const item = gridlist.find(grid => grid.id === id);
        return isEmpty(item) ? '' : item.type;
    }

    function existTotal(id) {
        return gridlist.some(item => item.id === 'T' + id);
    }

    function panelDomId(targetPanel) {
        return 'rawstockcnt_panel_' + targetPanel.id + '_' + targetPanel.type;
    }

    function showpanel(id, type, show) {
        setpanel(current => current.map(item =>
            item.id === id && item.type === type
                ? { ...item, hide: !show }
                : item
        ));
    }

    function SetLayout(newColumns, type) {
        const nextFields = DeepCopy(textfields.filter(item => item.type !== type));
        newColumns.forEach(columnId => {
            const column = textfieldsall.find(item => item.columnid === columnId && item.type === type);
            if (!isEmpty(column)) nextFields.push(column);
        });
        settextfields(nextFields);
    }

    function SaveLayout(layoutid) {
        const coldef = [];

        panel.forEach(item => {
            if (item.id === G_id.BASE) {
                textfields
                    .filter(field => field.type === item.type && !field.hide)
                    .forEach(field => coldef.push({
                        headerName: field.columnnm,
                        table: field.table,
                        field: field.columnid,
                        width: field.width,
                        type: field.type
                    }));
                return;
            }

            if (!item.grid || isEmpty(AGRef.current)) return;
            const api = gridApi(item);
            if (isEmpty(api)) return;
            const shownColumns = AGRef.current.GetshownColDef(api) || [];
            shownColumns.forEach(column => {
                const nextColumn = DeepCopy(column);
                nextColumn.type = item.type;
                coldef.push(nextColumn);
            });
        });

        fnc.current.postaxios(
            'common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function () {
                    dispatch(addentrylayout({ value: layoutid, label: layoutid }));
                    fnc.current.success();
                    fnc.current.wait(false);
                }
            }
        );
    }

    function DeleteLayout(layoutid) {
        fnc.current.postaxios(
            'common/DeleteEntryLayout',
            { controller: controller, subkey: subkey, code: layoutid },
            {
                onSuccess: function (data) {
                    dispatch(setentrylayout((mainlayout || []).filter(item => item.value !== layoutid)));
                    if (data.request !== maininitlayout) {
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: ' ',
                            fitColumn: false
                        }));
                    }
                    fnc.current.success();
                    fnc.current.wait(false);
                }
            }
        );
    }

    function CallLayout(layoutid) {
        fnc.current.postaxios(
            'common/LoadLayout',
            { controller: controller, subkey: subkey, code: layoutid },
            {
                onSuccess: function (data) {
                    const layoutColumns = applyRawStockCntFieldWidths(data.columns);
                    gridlist.forEach(item => {
                        const index = gridIndex(item);
                        if (index === -1) return;
                        const coldef = AGRef.current.createColDef(
                            (columninfo || []).filter(column => column.type === item.type),
                            layoutColumns.filter(column => column.type === item.type),
                            false
                        );
                        if (coldef.length !== 0) gridcolRefs.current[index].current = coldef;
                    });
                    setpanel(data.panels || []);
                    settextfields(layoutColumns.filter(item => item.logpid === G_id.BASE));
                    setcolumns(layoutColumns);
                    rerender();
                    fnc.current.wait(false);
                }
            }
        );
    }

    function Jump(targetPanel) {
        showpanel(targetPanel.id, targetPanel.type, true);
        window.setTimeout(() => {
            const element = document.getElementById(panelDomId(targetPanel));
            if (isEmpty(element) || isEmpty(entryBodyRef.current)) return;
            entryBodyRef.current.scrollTop = Math.max(0, element.offsetTop - 5);
        }, 0);
    }

    function Contents({ panel: targetPanel }) {
        if (targetPanel.id === G_id.BASE) {
            return (
                <div id={'basepanel' + targetPanel.type}>
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={targetPanel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                    />
                </div>
            );
        }

        if (targetPanel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            );
        }

        if (targetPanel.grid) {
            const index = gridIndex(targetPanel);
            if (index === -1) return null;
            return (
                <React.Fragment>
                    <EntryGridAr
                        key={fnc.current.GridID(targetPanel) + '-' + detailMaterialCategory}
                        id={fnc.current.GridID(targetPanel)}
                        entrydataRef={entrydataRef}
                        dataRef={griddataRefs.current[index]}
                        columnRef={gridcolRefs.current[index]}
                        columninfo={columninfo}
                        columns={columns}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        ValueChanged={params => detailValueChanged(targetPanel, params)}
                        RowValueChanged={(columnId, rows) => updateDetailAndTotal(targetPanel, rows)}
                        ColdefSpecial={applyRawStockCntDetailSearch}
                        QuerySearchClick={queryRawStockCntDetailSearch}
                        formid={formid}
                        panel={targetPanel}
                    />
                    {!existTotal(targetPanel.id) ? null :
                        <EntryGridAr
                            id={fnc.current.GridID('T' + targetPanel.id)}
                            entrydataRef={entrydataRef}
                            dataRef={griddataRefs.current[gridIndex({ id: 'T' + targetPanel.id })]}
                            columnRef={gridcolRefs.current[gridIndex({ id: 'T' + targetPanel.id })]}
                            columninfo={columninfo}
                            columns={columns}
                            fnc={fnc}
                            onFirstDataRendered={onFirstDataRendered}
                            formid={formid}
                            panel={targetPanel}
                            total={true}
                            totaltype={tabletype('T' + targetPanel.id)}
                        />
                    }
                </React.Fragment>
            );
        }

        if (targetPanel.id === G_id.FILE) {
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            );
        }

        if (targetPanel.id === G_id.NB) {
            const def = (columninfo || []).find(item => item.type === targetPanel.type);
            return (
                <EntryRemarks
                    id={'remarkspanel' + targetPanel.type}
                    def={def}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                />
            );
        }

        return null;
    }

    function EntryForm() {
        return (
            <div
                ref={entryBodyRef}
                style={{
                    padding: '5px 15px',
                    paddingBottom: 300,
                    height: '100%',
                    overflow: 'auto',
                    backgroundColor: '#D8D8D8'
                }}
            >
                {panel.map(item => (
                    <Box
                        key={item.id + '_' + item.type}
                        id={panelDomId(item)}
                        display={item.hide ? 'none' : 'flex'}
                        justifyContent="space-around"
                        alignItems="center"
                        padding="5px"
                    >
                        <Paper style={{ width: '100%', height: 'auto', padding: 10 }}>
                            <div style={{ position: 'relative', marginBottom: 5 }}>
                                {item.name} - <span style={{ fontStyle: 'oblique' }}>{item.name2}</span>
                                {item.id !== G_id.BASE ? null :
                                    <div style={{ position: 'absolute', right: 35, top: -6 }} title="項目設定">
                                        <IconButton
                                            size="small"
                                            onClick={() => fnc.current.entrylayoutopen(item.type)}
                                        >
                                            <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                        </IconButton>
                                    </div>
                                }
                                <div style={{ position: 'absolute', right: 5, top: -6 }}>
                                    <IconButton
                                        size="small"
                                        title="セクションを閉じる"
                                        onClick={() => showpanel(item.id, item.type, false)}
                                    >
                                        <Icon style={{ fontSize: 16 }}>close</Icon>
                                    </IconButton>
                                </div>
                            </div>
                            <Contents panel={item} />
                        </Paper>
                    </Box>
                ))}
            </div>
        );
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                ref={baseRef}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                tabs={true}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                usecondition={true}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                entryform={true}
                show={Show}
                primarykey={primarykeys}
                suppressaction={suppressaction}
                tabvalueChange={type => setViewListType(String(type))}
            >
                <EntryForm />
            </MasterBase>
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields}
                onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton
                            size="small"
                            onClick={() => fnc.current.entrysettingopen()}
                            title="レイアウト設定"
                        >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            component="div"
                            elevation={0}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 5,
                                padding: 4,
                                backgroundColor: 'transparent'
                            }}
                        >
                            {panel.map(item => (
                                <Chip
                                    key={'nav_' + item.id + '_' + item.type}
                                    label={item.name}
                                    title={item.name}
                                    size="small"
                                    onClick={() => Jump(item)}
                                />
                            ))}
                        </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
        </div>
    );
};
